import { HTMLAttributes } from 'react';
import { Sound, playSound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { useLayoutSelector } from '../../redux';
import { StyledCount, StyledTab, StyledTabContainer } from './Tab.styled';

interface ITab {
	text: string;
	icon: string;
	count?: number;
	color?: string;
	$selected?: boolean;
}

const Tab = ({
	text,
	count,
	color,
	$selected,
	...props
}: ITab & HTMLAttributes<HTMLDivElement>) => {
	const reportVisible = useLayoutSelector(
		(state) => state.mainMenu.reportVisible,
	);

	return (
		<StyledTabContainer
			$color={color}
			{...props}
			onClick={(e) => {
				props.onClick?.(e);
				playSound(Sound.ClickButton);
			}}
		>
			<StyledTab
				$selected={$selected && !reportVisible}
				$color={color}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<Text>{text}</Text>
			</StyledTab>
			{count ? (
				<StyledCount>
					<Text>{count > 9 ? '∞' : count}</Text>
				</StyledCount>
			) : null}
		</StyledTabContainer>
	);
};

export { Tab };
